import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { TagService } from '../../../services/TagService';

interface Props {
    ownedTags: ReqType.Tag[];
    setOwned: (arr: ReqType.Tag[]) => void;
    removeTag: (arr: ReqType.Tag) => Promise<void>;
    addTag: (arr: ReqType.Tag) => Promise<void>;
}

interface State {
    tags: ReqType.Tag[];
}

export class TagCard extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            tags: [],
        };
        this.getTags();
    }

    render() {
        return (
            <div className="card card-default">
                <div className="card-header ">
                    <h4 className="text-white">
                        <strong>Tags</strong>
                    </h4>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-6">
                            <div className="card card-default">
                                <div className="card-header ">
                                    <h4 className="text-white">
                                        <strong> Tags disponibles</strong>
                                    </h4>
                                </div>
                                <div className="card-body">
                                    {this.getDispos()}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="card card-default">
                                <div className="card-header" >
                                    <h4 className="text-white">
                                        <strong>Tags attitrés</strong>
                                    </h4>
                                </div>
                                <div className="card-body">
                                    {this.getOwned()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private getTags() {
        TagService.getInstance().getTags()
            .then(
                (tags: ReqType.Tag[]) => {
                    this.setState({ tags: tags });
                }
            );
    }

    private getDispos() {
        return this.state.tags
            .filter(
                (elem: ReqType.Tag) => {
                    return (
                        this.props.ownedTags.find((elemFind: ReqType.Tag) => {
                            return elem.id === elemFind.id;
                        }) === undefined
                    );
                }
            )
            .map(
                (elem: ReqType.Tag) => {
                    return (
                        <div
                            className="badge badge-danger"
                            key={elem.id}
                            style={{cursor: 'pointer', padding: '10px', marginRight: '10px', marginBottom: '5px'}}
                            onClick={
                                () => {
                                    this.props.addTag(elem).then(
                                        () => {
                                            this.props.ownedTags.push(elem);
                                            this.props.setOwned(this.props.ownedTags);
                                        }
                                    );
                                }
                            }
                        >
                            {elem.nom}
                        </div >
                    );
                }
            );
    }

    private getOwned() {
        return this.props.ownedTags.map(
            (elem: ReqType.Tag) => {
                return (
                    <div
                        className="badge badge-danger"
                        key={elem.id}
                        style={{cursor: 'pointer', padding: '10px', marginRight: '10px', marginBottom: '5px'}}
                        onClick={
                            () => {
                                this.props.removeTag(elem).then(
                                    () => {
                                        var arr = this.props.ownedTags.filter(
                                            (elemFound: ReqType.Tag) => {
                                                return elemFound.id !== elem.id;
                                            }
                                        );
                                        this.props.setOwned(arr);
                                    }
                                );
                            }
                        }
                    >
                        {elem.nom}
                    </div>
                );
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Tag/TagCard.tsx